export const getDistinctItemsWithProperties = (
  array: any[],
  propertyKey: string
) => {
  const distinctItemsMap = new Map();

  for (const item of array) {
    distinctItemsMap.set(item[propertyKey], item);
  }

  return Array.from(distinctItemsMap.values());
};

/*
 * Returns an array of dropdown items from an enum object
 */
export const getDropdownItemsByEnum = <T extends Record<string, string>>(
  enumObject: T
): { value: string; label: string }[] => {
  return [
    { value: "", label: "" },
    ...Object.entries(enumObject).map(([key, value]) => ({
      label: value,
      value: key,
    })),
  ];
};

/**
 * Generates a query string from a given object of parameters.
 * @param params - An object containing the parameters to be included in the query string.
 * @returns The generated query string.
 */
export const generateQueryString = (params: Record<string, any>): string => {
  let queryString = "";
  for (const key in params) {
    if (params[key] !== undefined) {
      queryString += `${key}=${params[key]}&`;
    }
  }
  if (queryString.endsWith("&")) {
    queryString = queryString.slice(0, -1);
  }
  return queryString;
};
